import $ from 'jquery';
import _ from 'underscore';
import MappingBase from "./MappingBase";
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let infoWindowTemplate = require("../../hbs-templates/infoWindowBcp.handlebars");
let bcpListTemplate = require("../../hbs-templates/bcpLocationsList.handlebars");

/**
 * @file BcpMap.js
 */
class BcpMap extends MappingBase {
  constructor() {
    super();

    // Set defaults
    this.allMarkers = [];
    this.allInfoWindows = [];
    this.allLocations = [];

    // Get data and load map
    this.getData();
  }

  /**
   * Gets data from the backend
   */
  getData() {
    // Load locations
    fetch(window.location.origin + '/api/bcp',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => {
      if (response.ok) {
        response.json().then((r) => {
          this.allLocations = r;

          // Load map
          this.loadMap();

          // Load list view
          this.loadListView(this.allLocations);
        });
      }
      else {
        console.log('Error getting data');
      }
    });
  };

  /**
   * Loads the list view of alerts
   *
   * @param locations
   */
  loadListView(locations) {
    // Filter out locations without alerts
    let locationsWithAlerts = _.filter(locations, function(l) {
      return l.hasOwnProperty('Alerts');
    });

    if (locationsWithAlerts) {
      // Group locations by incident ID
      let alertsGrouped = _.groupBy(locationsWithAlerts, function (a) {
        return a.Alerts.IncidentId;
      });

      // Organize data
      let alertData = [];
      alertsGrouped = _.toArray(alertsGrouped);
      for (let i = 0; i < alertsGrouped.length; i++) {
        let alert = _.first(alertsGrouped[i]).Alerts;
        alertData.push({
          'Status': alert.Status,
          'Title': alert.Title,
          'Date': alert.StatusDate,
          'Locations': _.pluck(alertsGrouped[i], 'Title').join(', '),
          'Details': alert.Message
        });
      }

      // Order by date (desc)
      let alertsSorted = _.sortBy(alertData, function(a) {
        let dt = new Date(a.Date);
        return -dt;
      });

      $('.locations-list-container').html(
        bcpListTemplate(alertsSorted)
      );
    } else {
      // No active alerts
      $('.locations-list-container').html(
        bcpListTemplate()
      );
    }
  };

  /**
   * Loads the map and plots the locations
   */
  async loadMap() {
    setOptions({
      key: drupalSettings.loomis_maps.api_key,
      v: 'weekly',
    });

    const { Map } = (await importLibrary('maps'));

    let mapOptions = {
      zoom: 4,
      minZoom: 4,
      center: new google.maps.LatLng(39.8282, -98.5795),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: 'BCP_Map'
    };

    this.map = new Map(document.getElementById('locations'), mapOptions);

    // Create markers and info windows
    if (this.allLocations) {
      for (let i = 0; i < this.allLocations.length; i++) {
        await this.createMarker(this.map, this.allLocations[i]);
      }
    }
  };

  /**
   * Creates a marker and info window and adds it to the map
   *
   * @param map
   * @param location
   */
  async createMarker(map, location) {
    let latLng = new google.maps.LatLng(
      parseFloat(location.Lat),
      parseFloat(location.Lng)
    );

    // Create the AdvancedMarkerElement container
    const container = document.createElement("div");
    container.className = "marker-container";

    // Populate location data
    container.innerHTML = infoWindowTemplate(location);

    // Wire up close button
    const closeBtn = container.querySelector(".close-btn");
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      container.classList.remove("is-expanded");
    });

    container.addEventListener("click", () => {
      this.openMarkerById(location.Nid);
    });

    // Now actually create the marker and add to the map
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: latLng,
      content: container,
      gmpClickable: true
    });

    // Add to collection
    this.allMarkers[location.Nid] = marker;
  };

  /**
   * Opens a saved marker by Node ID
   *
   * @param Nid
   */
  openMarkerById(Nid) {
    const targetMarker = this.allMarkers[Nid];
    this.allMarkers.forEach((marker) => {
      marker.content.classList.remove('is-expanded');
      marker.zIndex = 0;
    });

    targetMarker.content.classList.add('is-expanded');
    targetMarker.zIndex = 9999;
    this.map.panTo(targetMarker.position);
  };
}

// Load map once we confirm we have the API key
if (drupalSettings.loomis_maps.api_key) {
  let bcpMap = new BcpMap();
}
